// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3YOLd","log":"ModalInventoryLogs_log__2i0fd","date":"ModalInventoryLogs_date__1ruP8","userName":"ModalInventoryLogs_userName__nYbhH"};